var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.71 7.29a1 1 0 00-1.42 0L11 9.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42L9.59 11l-2.3 2.29a.999.999 0 000 1.42 1 1 0 001.42 0l2.29-2.3 2.29 2.3a1 1 0 001.42 0 1.001 1.001 0 000-1.42L12.41 11l2.3-2.29a1.001 1.001 0 000-1.42zm3.36-3.36A10 10 0 103.93 18.07 10 10 0 1018.07 3.93zm-1.41 12.73A8 8 0 1119 11a7.948 7.948 0 01-2.34 5.66z",
    fill: "#F2335C"
  })));
}
export default SvgErrorOutlined;